import { render, staticRenderFns } from "./EditProject.vue?vue&type=template&id=5ebe6cf2&scoped=true"
import script from "./EditProject.vue?vue&type=script&lang=js"
export * from "./EditProject.vue?vue&type=script&lang=js"
import style0 from "./EditProject.vue?vue&type=style&index=0&id=5ebe6cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebe6cf2",
  null
  
)

export default component.exports